
import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-BR')

export default (data, hora, isNewTZ = true, progress = 'unknown', rangeInMinutes = 0) => {
  const fmtStartDate = (isNewTZ ? moment.utc(data) : moment(data)).format('YYYY-MM-DD')

  // UNIX TIMESTAMP DO INÍCIO DO PLANTÃO
  const shiftStart = moment(`${fmtStartDate} ${hora}:00`, 'YYYY-MM-DD HH:mm:ss').unix()
  // UNIX TIMESTAMP DE AGORA
  const now = (isNewTZ ? moment.utc() : moment()).unix()
  // LIMITE DO INTERVALO ENTRE AGORA E O INÍCIO
  const rangeInSeconds = rangeInMinutes * 60

  return (progress !== 'started') && (now > shiftStart) && ((now - shiftStart) > rangeInSeconds)
}
